// extracted by mini-css-extract-plugin
export default {"main":"Image_main__9nbok","image":"Image_image__KaWNk"};